import React from "react";
import EventBanner from "./EventBanner";

const DashboardMockup = () => {
  return (
    <div
      className="relative w-full max-w-[90vw] sm:max-w-[520px]"
      data-testid="hero-dashboard-mock"
    >
      {/* Glow blobs */}
      <div className="absolute -top-10 -right-10 h-56 w-56 rounded-full bg-ibh-orange/30 blur-3xl"></div>
      <div className="absolute -bottom-10 -left-10 h-56 w-56 rounded-full bg-ibh-green/30 blur-3xl"></div>
      {/* Card with image */}
      <div className="relative h-full w-full rounded-3xl border border-slate-200/70 shadow-soft overflow-hidden bg-white">
        <img
          src="/Graph.avif"
          alt="Business Growth"
          className="w-full h-full object-contain p-2"
        />
      </div>
    </div>
  );
};

const Hero = () => {
  return (
    <section
      id="top"
      className="relative pt-28 sm:pt-36 pb-16 sm:pb-24 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-ibh-bg to-ibh-bg"></div>
        <div className="absolute inset-0 grid-bg opacity-50"></div>
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 h-[520px] w-[820px] rounded-full bg-ibh-gradient-soft blur-3xl"></div>
      </div>

      {/* Event banner now sits at the top of the hero, countdown included inside it */}
      <EventBanner />

      <div className="section">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6 reveal">
          <div className="chip" data-testid="hero-eyebrow">
            <span className="h-1.5 w-1.5 rounded-full bg-ibh-green"></span>
            The Complete Business Support Ecosystem
          </div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-slate-900">
            One Platform.{" "}
            <span className="gradient-text">Complete Business Support.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-600 max-w-xl">
            From your first idea to scaling crores in revenue — IBH connects
            founders, MSMEs and entrepreneurs with helpline support, vetted
            experts, funding networks and a thriving Indian business community.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="tel:+918274964884"
              className="hidden sm:inline-flex btn-primary !py-2.5 !px-5"
              data-testid="nav-cta-talk-to-expert"
            >
              <i className="fa-solid fa-headset text-xs"></i>
              Talk to an Expert
            </a>
            <a
              href="#membership"
              className="btn-secondary"
              data-testid="hero-cta-secondary"
            >
              Explore Membership
              <i className="fa-solid fa-arrow-right text-xs"></i>
            </a>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-2 sm:gap-4 max-w-md">
            {[
              { v: "₹11.5Cr+", l: "Funding Processed" },
              { v: "25+", l: "Vetted Experts" },
            ].map((s) => (
              <div key={s.l} data-testid={`hero-stat-${s.l}`}>
                <p className="font-display text-lg sm:text-2xl font-bold text-slate-900 truncate">
                  {s.v}
                </p>
                <p className="text-xs text-slate-500 mt-0.5">{s.l}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6 flex justify-center lg:justify-end reveal order-first lg:order-last">
          <DashboardMockup />
        </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;